export type BrandIconVariant = "monet" | "regular";

export const BRAND_ICON_STORAGE_KEY = "fintheon:brand-icon-variant";

export const BRAND_ICON_ASSETS: Record<
  BrandIconVariant,
  {
    label: string;
    detail: string;
    src: string;
  }
> = {
  monet: {
    label: "Monetmorphism",
    detail: "Default app icon",
    src: "/brand/fintheon-app-icon-monet.png",
  },
  regular: {
    label: "Regular",
    detail: "Brand chrome override",
    src: "/brand/fintheon-logo-regular.png",
  },
};

export function isBrandIconVariant(value: unknown): value is BrandIconVariant {
  return value === "monet" || value === "regular";
}

export function loadStoredBrandIconVariant(): BrandIconVariant {
  try {
    const stored = localStorage.getItem(BRAND_ICON_STORAGE_KEY);
    return isBrandIconVariant(stored) ? stored : "monet";
  } catch {
    return "monet";
  }
}

export function saveBrandIconVariant(variant: BrandIconVariant) {
  try {
    localStorage.setItem(BRAND_ICON_STORAGE_KEY, variant);
  } catch {}
}

export function getBrandIconSrc(variant: BrandIconVariant) {
  return BRAND_ICON_ASSETS[variant].src;
}

export function applyBrandIconVariantToDOM(variant: BrandIconVariant) {
  if (typeof document === "undefined") return;
  const src = getBrandIconSrc(variant);
  setIconLink({ rel: "icon", src });
  setIconLink({ rel: "apple-touch-icon", src });
}

function setIconLink({ rel, src }: { rel: string; src: string }) {
  let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = `${src}?v=${Date.now()}`;
  if (rel === "icon") link.type = "image/png";
}
